
const reasons = [
  'Local Miami service',
  'Quality work + clean installs',
  'Honest recommendations',
  'Quick communication',
];

export default function WhyChooseUs() {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-charcoal text-center mb-12">
          Why Central Pool and Spa
        </h2>

        <div className="space-y-6">
          {reasons.map((reason, index) => (
            <div key={index} className="flex items-center gap-4 pb-6 border-b border-gray-200 last:border-0">
              <div className="flex-shrink-0 w-10 h-10 bg-tropical-teal rounded-full flex items-center justify-center">
                <i className="ri-check-line text-white text-xl"></i>
              </div>
              <div className="text-lg md:text-xl text-slate-gray font-medium">{reason}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
